import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  ArrowLeft, 
  Check, 
  RefreshCw, 
  ShoppingBag, 
  Sun, 
  Lock, 
  ArrowRight, 
  CreditCard, 
  CheckCircle,
  Award,
  Bell
} from 'lucide-react';
import styles from './PackTypeSelection.module.css';
import {LanguageSwitcher} from '../components/LanguageSwitcher'
import { useTranslate } from '../components/UseTranslate';


export default function PackTypeSelection() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('subscription');


  const {t} = useTranslate()

  const location = useLocation();

  const msisdn = location?.state?.msisdn
  const alias = location?.state?.alias
  console.log(location.state,'------------------')


  const handleTypeSelect = (type) => {
    setSelectedType(type);
  };

  console.log(selectedType,'selected ------------------')

  const handleContinue = () => {
    navigate(`/pack/${selectedType}`,{state:{msisdn:msisdn,alias:alias,packType:selectedType}});
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.container}>
        {/* Header */}
        <header className={styles.packTypeHeader}>
          <button className={styles.backBtn} onClick={() => navigate(-1)}>
            <ArrowLeft className={styles.backIcon} size={16} />
            <span>{t('Back')}</span>
          </button>
          
          <div className={styles.stepperContainer}>
            <div className={styles.stepper}>
              <div className={styles.stepConnector}>
                <div className={styles.connectorLineActive}></div>
              </div>
              
              <div className={`${styles.stepItem} ${styles.stepCompleted}`}>
                <div className={styles.stepCircle}>
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className={styles.stepTitle}>1.{t('Your Number')} </span>
              </div>
              
              <div className={`${styles.stepItem} ${styles.stepCompleted}`}>
                <div className={styles.stepCircle}>
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className={styles.stepTitle}>2.{t('OTP')}</span>
              </div>
              
              <div className={styles.stepItem}>
                <div className={styles.stepCircle}>3</div>
                <span className={styles.stepTitle}>3.{t('Pack Type')} </span>
              </div>
              
              <div className={styles.stepItem}>
                <div className={styles.stepCircle}>4</div>
                <span className={styles.stepTitle}>4. {t('Choose Plan')}</span>
              </div>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className={styles.heroSection}>
          <div className={styles.heroLeft}>
            <div className={styles.stepBadge}>
              <Sun size={14} className={styles.sunIcon} />
              <span>{t('STEP 1 OF 2')}</span>
            </div>
            <h1 className={styles.heroTitle}>
              <span className={styles.highlightText}>{t('Discover Delicious')}</span> <br />
              <span className={styles.startsHereWrapper}>
                {t('Recipes')}
                <svg className={styles.scribbleUnderline} viewBox="0 0 200 20" width="100%" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 15 Q 50 8, 100 12 T 195 10" stroke="#ff6600" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </span>
            </h1>
            <p className={styles.heroSubtitle}>
              {t('Unlock delicious recipes, cooking tips, and meal ideas to inspire your next dish.')}
            </p>
          </div>
          
          <div className={styles.heroRight}>
            <div className={styles.foodImageContainer}>
              <div className={styles.glowOverlay}></div>
              <img 
                src={`/images/aesthetic.png`} 
                alt="Perfect Meal Prep Box" 
                className={styles.foodImage}
              />
            </div>
          </div>
        </section>

        {/* Selection Cards */}
        <div className={styles.packTypeCards}>
          {/* Subscription Packs */}
          <motion.div
            className={`${styles.packTypeCard} ${selectedType === 'subscription' ? styles.packTypeCardSelected : ''}`}
            onClick={() => handleTypeSelect('subscription')}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
          >
            {selectedType === 'subscription' && (
              <div className={styles.cardCheckmark}>
                <Check size={12} strokeWidth={4} />
              </div>
            )}
            
            {/* <span className={styles.popularBadge}>
              <Award size={12} fill="white" className={styles.badgeIcon} />
              {t('MOST POPULAR')}
            </span> */}

            <div className={styles.cardHeader}>
              <div className={styles.iconCircleOrange}>
                <RefreshCw size={28} className={styles.spinIcon} />
              </div>
              <div className={styles.cardHeaderTitleGroup}>
                <h3 className={styles.cardTitle}>{t('SUBSCRIPTION PACKS')}</h3>
                <p className={styles.cardSubtextOrange}>{t('Unlimited access to premium recipes')}</p>
              </div>
            </div>

            <div className={styles.cardDivider}></div>

            <div className={styles.featureGrid}>
              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <RefreshCw size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('Auto Renewal')}</span>
                  <span className={styles.featureSub}>{t('Hassle-free and convenient')}</span>
                </div>
              </div>

              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <RefreshCw size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('Unlimited Recipes')}</span>
                  <span className={styles.featureSub}>{t('Access our complete recipe collection')}</span>
                </div>
              </div>

              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <Bell size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('Premium Cooking Tips')}</span>
                  <span className={styles.featureSub}>{t('Learn techniques from expert chefs')}</span>
                </div>
              </div>
            </div>

         
          </motion.div>

          {/* OR Divider */}
          <div className={styles.orBadge}>
            <span>{t('OR')}</span>
          </div>

          {/* One-Time Order */}
          <motion.div
            className={`${styles.packTypeCard} ${selectedType === 'one time' ? styles.packTypeCardSelected : ''}`}
            onClick={() => handleTypeSelect('one time')}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
          >
            {selectedType === 'one time' && (
              <div className={styles.cardCheckmark}>
                <Check size={12} strokeWidth={4} />
              </div>
            )}

            <div className={styles.cardHeader}>
              <div className={styles.iconCircleGray}>
                <ShoppingBag size={28} />
              </div>
              <div className={styles.cardHeaderTitleGroup}>
                <h3 className={styles.cardTitle}>{t('ONE-TIME PURCHASE OFFER')}</h3>
                <p className={styles.cardSubtextOrange}>{t('Get instant access to selected recipes')}</p>
              </div>
            </div>

            <div className={styles.cardDivider}></div>

            <div className={styles.featureGrid}>
              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <ShoppingBag size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('No Commitment')}</span>
                  <span className={styles.featureSub}>{t('Pay once only')}</span>
                </div>
              </div>

              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <CreditCard size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('Instant Purchase')}</span>
                  <span className={styles.featureSub}>{t('Start cooking immediately')}</span>
                </div>
              </div>

              <div className={styles.featureBox}>
                <div className={styles.featureIconCircle}>
                  <CheckCircle size={14} />
                </div>
                <div className={styles.featureTextGroup}>
                  <span className={styles.featureTitle}>{t('Flexible Choice')}</span>
                  <span className={styles.featureSub}>{t('Purchase only what you need')}</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom CTA */}
        <div className={styles.bottomSection}>
          <button className={styles.continueButton} onClick={handleContinue}>
            <span>{t('Continue')}</span>
            <ArrowRight size={18} className={styles.continueIcon} />
          </button>
          
          {/* <div className={styles.secureText}>
            <Lock size={14} className={styles.lockIcon} />
            <span>Secure & Protected Checkout</span>
          </div> */}
        </div>
      </div>
      <LanguageSwitcher/>
    </div>
  );
}
